import ContactApi from './rest/ContactApi';

export default new ContactApi();
